import { render, staticRenderFns } from "./ParkingBarriers.vue?vue&type=template&id=31add4f5&scoped=true&"
import script from "./ParkingBarriers.vue?vue&type=script&lang=js&"
export * from "./ParkingBarriers.vue?vue&type=script&lang=js&"
import style0 from "./ParkingBarriers.vue?vue&type=style&index=0&id=31add4f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31add4f5",
  null
  
)

export default component.exports